import { render } from "./NetworkLobby.vue?vue&type=template&id=0ca1e50b&ts=true"
import script from "./NetworkLobby.vue?vue&type=script&lang=ts"
export * from "./NetworkLobby.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__